import { render, staticRenderFns } from "./EditMetaComponent.vue?vue&type=template&id=6f201636&scoped=true&"
import script from "./EditMetaComponent.vue?vue&type=script&lang=js&"
export * from "./EditMetaComponent.vue?vue&type=script&lang=js&"
import style0 from "./EditMetaComponent.vue?vue&type=style&index=0&id=6f201636&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f201636",
  null
  
)

export default component.exports